import React from 'react';
import Slot from 'react-slot-machine';
import { throttle as _throttle } from 'lodash';
import './tech-slots.scss';
import TechIcon from '../ImageSlider/TechIcon';
import technologyData from '../../data/json/technologies.json';
import BREAKPOINTS from '../../data/json/breakpoints.json';

class TechSlots extends React.Component {
  constructor() {
    super();
    this.timer = null;
    this.state = {
      target1: 1,
      target2: 2,
      target3: 3,
      target4: 4,
      target5: 5,
      times: 5,
      duration: 3000,
      turn: true,
      columns: this.getNumberOfColumns(),
    };
  }

  createRandomTargets = () => {
    this.setState({
      target1: Math.floor(Math.random() * technologyData.length) + 1,
      target2: Math.floor(Math.random() * technologyData.length) + 1,
      target3: Math.floor(Math.random() * technologyData.length) + 1,
      target4: Math.floor(Math.random() * technologyData.length) + 1,
      target5: Math.floor(Math.random() * technologyData.length) + 1,
    });
  };

  getNumberOfColumns = () => {
    let noOfColumns = 0;
    if (
      window.innerWidth > BREAKPOINTS.xs &&
      window.innerWidth < BREAKPOINTS.sm
    ) {
      noOfColumns = 1;
    } else if (
      window.innerWidth > BREAKPOINTS.sm &&
      window.innerWidth < BREAKPOINTS.md
    ) {
      noOfColumns = 2;
    } else if (
      window.innerWidth > BREAKPOINTS.md &&
      window.innerWidth < BREAKPOINTS.lg
    ) {
      noOfColumns = 3;
    } else if (
      window.innerWidth > BREAKPOINTS.lg &&
      window.innerWidth < BREAKPOINTS.xl
    ) {
      noOfColumns = 4;
    } else {
      noOfColumns = 5;
    }
    return noOfColumns;
  };

  componentDidMount = () => {
    this.timer = setInterval(this.createRandomTargets.bind(this), 4000);
    // Throttle to 500ms to avoid "freezing" on window resize
    window.addEventListener('resize', this.updateWindowDimensions);
  };

  componentWillUnmount = () => {
    clearInterval(this.timer);
    window.removeEventListener('resize', this.updateWindowDimensions);
  };

  updateWindowDimensions = () => {
    this.setState({ columns: this.getNumberOfColumns() });
  }

  render() {
    return (
      <section
        id="technologies-slots"
        className="container tech-slot-container"
      >
        <div className="row slot-row">
          {Array.from(Array(this.state.columns), (e, i) => {
            let targetValue = `target${i + 1}`;
            // console.log(this.state[targetValue]);
            return (
              <div
                className="slot-column"
                style={{width: `${100/this.state.columns}%`}}
                key={i}
              >
                <Slot
                  className="slot"
                  duration={this.state.duration}
                  target={
                    this.state.turn ? parseInt(this.state[targetValue]) : 0
                  }
                  times={this.state.times}
                >
                  {technologyData.map((tech, index) => {
                    return (
                      <div className="tech-tile" key={index}>
                        <h5>{tech.name}</h5>
                        <TechIcon icon={tech.icon} />
                        <h6>Last used - {tech.lastUsed}</h6>
                      </div>
                    );
                  })}
                </Slot>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

export default TechSlots;



// WEBPACK FOOTER //
// ./src/components/TechSlots/TechSlots.js